module.exports = __webpack_public_path__ + "img/xinwen_img_03.eae02619.jpg";